import * as React from "react";

import { Grid, Typography } from '@material-ui/core'
import { Link } from 'react-router-dom';
import { numberWithCommas, fixToPersianNumbers } from '../../../../utils/helpers';
import classes from './index.module.scss';
import ProductRepository from "client-sdk/src/Repository/product-repository";


type image = { [key: number]: string }
type Product = {
  id: number;
  description: string;
  inventoryDTO?: any;
  price: number;
  name: string
}
type Products = {
  products: any
}

const MostOrdered = (props: Products) => {
  const [images, setImages] = React.useState({} as image);

  React.useEffect(() => {
    getImages();
  }, [props.products])

  const getImages = async () => {
    props.products.forEach(async (prod: any) => {
      if (prod.imageName) {
        const image = await ProductRepository.getImagefromVitrin({ payload: { id: prod.id, fileName: prod.imageName } });
        setImages((prev: any) => {
          return {
            ...prev,
            [prod.id]: `data:${image?.headers['content-type']};base64,${image?.data}`
          }
        })
      }
    });
  }
  return (
    <div className='wrapper-lg'>
      <h2>پرفروش‌ترین کالاها در ویترین</h2>
      <Grid container spacing={3}>
        {props?.products.map((el: Product, i: number) => (
          <Grid item lg={3} style={{ position: "relative" }}>
            {/* <div className={classes.tag}>{fixToPersianNumbers(`${el.count}`)} سفارش</div> */}
            <div>
              {images[el.id] ? (
                <img src={`${images[el.id]}`} alt="product" className={classes.imgBox} />) :
                (<img src="/vitrin/images/nophoto.jpg" alt="product" className={classes.imgBox} />)}
            </div>
            <Link to={`products/${i}`} className="link">
              <Typography noWrap className={classes.description}>
                {el.description}
              </Typography>
            </Link>
            <p><span className='text-muted text-sm'>موجودی: </span><span>{fixToPersianNumbers(`${el?.inventoryDTO?.orderAble}`)} عدد</span></p>
            <p className='mt-2'><span className={classes.price}>{fixToPersianNumbers(numberWithCommas(el.price))} </span><span className='text-muted'>تومان</span></p>
          </Grid>
        ))}
      </Grid>
    </div>
  )
}

export default MostOrdered